<div class="d-flex align-items-stretch justify-content-between me-3 menu-header">
    <div class="site-search-wrapper">
        <div class="header-logo">
            <a href="javascript:void(0)" style="margin-left: 25px; margin-right: 15px">
                <img alt="Logo" src="../../../../../assets/media/logos/{{ CA }}" class="logo-sticky max-h-60px" />
            </a>
        </div>

        <ng-container *ngIf="headerMenuSelfDisplay" class="mobile_menu">
            <button class="btn p-0 burger-icon burger-icon-left ms-4" id="kt_header_mobile_toggle">
                <span></span>
            </button>
        </ng-container>

        <ng-container>
            <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
                <ng-container>
                    <div #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-left header-menu-mobile" [ngClass]="headerMenuCSSClasses">
                        <ul class="menu-nav" [ngClass]="ulCSSClasses">
                            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                                <a class="menu-link" routerLink="../home" [routerLinkActive]="['active']">
                                    <span class="menu-text">
                                        <i class="fas fa-home"></i>
                                        <!-- Home -->
                                        {{ 'INFORMATE_HEADER.Home' | transloco }}
                                    </span>
                                    <ng-container *ngIf="rootArrowEnabled">
                                        <i class="menu-arrow"></i>
                                    </ng-container>
                                </a>
                            </li>

                            <!-- <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                                <a class="menu-link" routerLink="/cdms/dashboard" [routerLinkActive]="['active']">
                                    <span class="menu-text">
                                        {{ 'INFORMATE_HEADER.DASHBOARD' | transloco }}
                                    </span>
                                    <ng-container *ngIf="rootArrowEnabled">
                                        <i class="menu-arrow"></i>
                                    </ng-container>
                                </a>
                            </li> -->

                            <!-- begin::1 Level -->
                            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isCompetencyModule">
                                <a class="menu-link" routerLink="/cdms/competencymodule" [routerLinkActive]="['active']">
                                    <span class="menu-text"> Compentency Module </span>

                                    <ng-container *ngIf="rootArrowEnabled">
                                        <i class="menu-arrow"></i>
                                    </ng-container>
                                </a>
                            </li>

                            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isCompetencyPersonnel">
                                <a class="menu-link" routerLink="/cdms/personnel" [routerLinkActive]="['active']">
                                    <span class="menu-text"> Personnel </span>
                                    <ng-container *ngIf="rootArrowEnabled">
                                        <i class="menu-arrow"></i>
                                    </ng-container>
                                </a>
                            </li>

                            <!-- <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isCompetencyEnrollments">
                                <a class="menu-link" routerLink="/cdms/enrollments" [routerLinkActive]="['active']">
                                    <span class="menu-text"> Enrollments </span>
                                    <ng-container *ngIf="rootArrowEnabled">
                                        <i class="menu-arrow"></i>
                                    </ng-container>
                                </a>
                            </li> -->

                            <!-- <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="isReports">
                                <a class="menu-link" routerLink="/idms/reports" [routerLinkActive]="['active']">
                                    <span class="menu-text"> Reports </span>
                                    <ng-container *ngIf="rootArrowEnabled">
                                        <i class="menu-arrow"></i>
                                    </ng-container>
                                </a>
                            </li> -->
                        </ul>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <!-- <ng-container *ngIf="siteSearchView && searchFormGroup">
        <form class="d-flex" [formGroup]="searchFormGroup" (ngSubmit)="searchedItemClick()">
            <div class="ml-auto menu_search_bar d-flex align-items-center" *ngIf="searchFormGroup">
                <div class="input-group">
                    <div class="form-outline">
                        <input type="search" formControlName="searchText" placeholder="Enter a search item" id="form1"
                            class="form-control search_sec_input" />
                        <div class="warning-message"
                            *ngIf="searchFormGroup.get('searchText')?.value && searchFormGroup.get('searchText')?.value?.length < 3">
                            <p>Your search needs to be at least 3 characters long.</p>
                        </div>
                    </div>
                    <a href="javascript:void(0)"><button type="submit" class="search_btn">
                            <i class="fas fa-search"></i></button></a>
                </div>

                <mat-select class="custom-select" panelClass="custom-select-option" formControlName="searchType">
                    <mat-option class="option-list" value="all">All</mat-option>
                    <mat-option class="option-list" value="taggedItems">Tagged Items</mat-option>
                    <mat-option class="option-list" value="projects">Project & Workpack</mat-option>
                    <mat-option class="option-list" value="documents">Documents</mat-option>
                </mat-select>
            </div>
        </form>
    </ng-container> -->
</div>
